<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" role="graphics-symbol">
    <g fill="currentColor">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM18.5459 5L13.3333 11.1032L19 19.412H14.8308L11.0135 13.8157L6.2348 19.412H5L10.4661 13.0126L5 5H9.1692L12.7831 10.2982L17.3111 5H18.5459ZM8.57747 5.93792H6.68047L15.4127 18.5202H17.3102L8.57747 5.93792Z"
      />
    </g>
  </svg>
</template>
